export default __webpack_public_path__ + "static/media/messageIcon.fd0b7ac9.png";